module.exports = __webpack_public_path__ + "5f64d0131d8f7f71f4c102e5c385afb0.svg";